/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import React from 'react';
import SearchComponent, { SearchComponentProps, Suggestion } from './SearchComponent';
import {
  searchUserByOrganization,
  searchUserByInitiative,
  searchUserBySurvey
} from '../../actions/common';
import Avatar from '../avatar';
import { searchUserByAssurancePortfolio } from '../../actions/assurance';

const renderSuggestion = (suggestion: Suggestion) => {
  return (
    <div className='suggestion-item'>
      <Avatar width='30px'>
        {suggestion.profile ? <img alt='avatar' src={suggestion.profile} /> : <></>}
      </Avatar>
      <span>
        <div><strong>{suggestion.name}</strong></div>
        <div><small>{suggestion.jobTitle}</small></div>
        <div><small>{suggestion.email}</small></div>
      </span>
    </div>
  );
}

interface UserSearchProps extends Omit<SearchComponentProps, 'renderSuggestion'> {
  organizationId?: string;
  surveyId?: string;
  initiativeId?: string;
  assurancePortfolioId?: string;
  ignoredIds?: string[];
};

const UserSearch = (props: UserSearchProps) => {
  let searchAction: undefined | ((searchStr: string) => Promise<Suggestion[]>);

  const filterIgnoredIds = (suggestions: Suggestion[]) => {
    if (props.ignoredIds && Array.isArray(suggestions)) {
      const ignoredIds = props.ignoredIds;
      return suggestions.filter(s => !ignoredIds.includes(s._id)) ?? [];
    }
    return suggestions ?? [];
  }

  switch (true) {
    case !!props.organizationId:
      searchAction = s => searchUserByOrganization(s, props.organizationId).then(filterIgnoredIds);
      break;
    case !!props.surveyId:
      searchAction = s => searchUserBySurvey(s, props.surveyId).then(filterIgnoredIds);
      break;
    case !!props.initiativeId:
      searchAction = s => searchUserByInitiative(s, props.initiativeId).then(filterIgnoredIds);
      break;
    case !!props.assurancePortfolioId:
      searchAction = s => searchUserByAssurancePortfolio(s, props.assurancePortfolioId).then(filterIgnoredIds);
      break;
    default:
  }

  const placeholder = props.placeholder || 'Search user';
  if (!searchAction) {
    return <input className='form-control' disabled={true} placeholder={placeholder} />;
  }

  return (
    <SearchComponent
      searchAction={searchAction}
      autoComplete={'user'}
      renderSuggestion={renderSuggestion}
      {...props}
      placeholder={placeholder}
    />
  );
}

export default UserSearch;
